// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../PageContentBlock';
import ResponsiveImage from '../ResponsiveImage';
import { Link } from '../Button';

type PropTypes = {|
  title: string,
  meta?: React.Node,
  summary: string,
  image: string,
  alt?: string,
  ctaHref: string,
  ctaText: string,
|};

const FeaturedItem = (props: PropTypes) => {
  return (
    <PageContentBlock background="DefaultContrast">
      <h2 className={styles.title}>Featured</h2>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          {props.meta && <div className={styles.meta}>{props.meta}</div>}
          <h3 className={styles.itemTitle}>{props.title}</h3>
          <p className={styles.text}>{props.summary}</p>
          <Link href={props.ctaHref}>{props.ctaText}</Link>
        </div>
        <div className={styles.imageContainer}>
          <ResponsiveImage
            className={styles.image}
            src={props.image}
            alt={props.alt}
            defaultSize={{ width: 512, height: 345 }}
            srcSet={[
              { mediaMaxWidth: 767, width: 703, height: 200 },
              { mediaMaxWidth: 600, width: 536, height: 200 },
              { mediaMaxWidth: 400, width: 336, height: 200 },
            ]}
          />
        </div>
      </div>
    </PageContentBlock>
  );
};

export default FeaturedItem;
